(function () {
    'use strict';

    if (typeof window === 'undefined') {

        const _ = require('lodash');

        // HACK-O-RAMA due to dependency cycles, delay initialization here
        // this is caused by a circular dependency between this file, and ./metrics/base.js
        const base = {
            shouldInitializeMetricModels: true,
            initializeMetricModels: function () {
                _.extend(this,
                    require('./metrics/base.js'),
                    baseRequire('models/metrics/socialPosts.js'),
                    baseRequire('models/metrics/facebookInsightsPost.js'),
                    baseRequire('models/metrics/fbAdsInsights.js'),
                    baseRequire('models/metrics/discovery.js'),
                    baseRequire('models/metrics/insights.js')
                );
            }
        };

        metric(
            module.exports,
            require('../metric/metric.js'),
            base,
            require('./metrics/dimensions.js'),
            require('./metrics/aggregates.js'),
            require('./metrics/expansions.js'),
            baseRequire('collections/metrics.js'),
            require('../data/channels.js'),
            _,
            require('../object.js'),
            {},
            require('../metrics.js'),
            require('d3'),
            require('../../enums/metrics.js'),
            require('../../enums/timePeriod.js'),
            require('../utils/timePeriod.js'),
            require('../formatter.js'),
            require('../../../lib/riq-moment.js'),
            require('object-hash')
        );

    } else {
        RivalIQ.module('collections', function () {});
        RivalIQ.module('metrics', function () {});

        metric(
            RivalIQ.models,
            RivalIQ.metric,
            RivalIQ.models.metrics,
            RivalIQ.models.metrics,
            RivalIQ.models.metrics,
            RivalIQ.models.metrics.expansions,
            RivalIQ.collections,
            RivalIQ.data.channels,
            window._,
            RivalIQ.Object,
            RivalIQ.enums.timeAnalysisMode,
            RivalIQ.metrics,
            window.d3,
            RivalIQ.enums,
            RivalIQ.enums.timePeriod,
            RivalIQ.utils.timePeriod,
            RivalIQ.formatter,
            window.moment,
            window.object_hash
        );
    }

    function metric(models, metricFn, base, dimensions, aggregates, expansions, collections, channels, _, BaseObject, timeAnalysisMode, metrics, d3, metricEnums, timePeriodEnums, timePeriodUtils, formatter, moment, objectHash) {

        // metric model mixins
        function mixin(metric) {
            // TODO do it for real
            _.extend(metric, Object.getPrototypeOf(metric.description));
        }

        function buildOver(metric, over) {
            if (!over) {
                return;
            }

            if (_.isString(over) || _.isArray(over)) {
                over = {
                    dimensions: over
                };
            }

            _.defaults(over, {
                aggregate: undefined,
                over: undefined
            });

            metric.attributes.over = over;

            metric.over = metric.build(over, {
                clobberDimensions: true
            });
        }

        models.MetricDefinition = BaseObject.extend({

            /**
             * The value to substitute for display when data is missing.
             */
            missingDataDisplayValue: '--',

            initialize: function (concept, attrs) {
                const me = this;

                if (_.isObject(concept)) {
                    attrs = concept;
                    concept = attrs.concept || null;
                } else if (_.isString(concept)) {
                    concept = _.get(metrics.descriptions, [concept, 'id'], parseInt(concept));
                }

                const description = _.find(metrics.descriptions, {
                    id: concept
                });
                if (_.isNull(concept)) {
                    me.cid = me.id = _.uniqueId('metric');
                    // TODO would like to get rid of id here, but currently
                    // needed to prevent model collisions
                    me.attributes = _.extend({}, attrs, {
                        id: me.id
                    });
                    _.extend(me, getMetricModel(me.attributes));
                    return;
                }

                const key = _.findKey(metrics.descriptions, {
                    id: concept
                });

                attrs = (_.isObject(attrs) ? attrs : {});
                me.attributes = _.extend(attrs, {
                    key: key,
                    id: concept,
                    concept: concept
                });

                _.defaults(me.attributes, {
                    property: _.get(description, 'property', 'count'),
                    returns: me.attributes.property || _.get(description, 'property', 'count')
                });

                me.description = description || {};
                if (!_.isUndefined(description)) {
                    me.source = metricEnums.sourceDetails[description.source];
                }

                me.id = me.concept = concept;
                me.cid = _.uniqueId('metric');

                mixin(me);
                buildOver(me, me.attributes.over);
            },

            get: function (key) {
                const me = this;
                return (_.isUndefined(me.attributes[key]) ? _.get(me.description, key) : me.attributes[key]);
            },

            getTitle: function (options) {
                const me = this;

                options = _.defaults(options || {}, {
                    abbreviate: true,
                    formatter: _.identity
                });

                let title = null;
                if (me.get('title')) {
                    title = me.get('title');
                } else if (options.abbreviate) {
                    title = (me.get('abbreviatedName') || me.get('name'));
                } else {
                    title = me.get('name');
                }

                return options.formatter(title);
            },

            getClassName: function (data) {
                const me = this;

                const className = me.get('className');
                if (className) {
                    return (_.isFunction(className) ? className(data) : className);
                }
            },

            getMissingFormat: function () {
                const me = this;
                return me.byField('missingFormat') || me.missingDataDisplayValue;
            },

            getEmptyStringFormat: function (data, options) {
                const me = this;
                return me.byProperty('emptyStringFormat', data, options);
            },

            getFormat: function (options) {
                const me = this;
                const formatter = me._getFormat(options);

                return function (val) {
                    if (me._isMissingValue(val)) {
                        return me.getMissingFormat(val);
                    }
                    return formatter(val);
                };
            },

            _isMissingValue: function (val) {
                return _.isNaN(val) || _.isNull(val) || _.isUndefined(val);
            },

            _getFormat: function (options) {
                const me = this;
                options = options || {};

                let format = me.get('format');
                if (!format) {
                    switch (options.value) {
                        case metricEnums.valueType.DELTA_REL:
                            format = '+,.2%';
                            break;
                        default:
                            break;
                    }
                }

                if (!format) {
                    switch (me.get('dataType')) {
                        case metricEnums.dataType.ABSOLUTE_PERCENT:
                            format = formatter.absolutePercent;
                            break;
                        case metricEnums.dataType.DURATION_SECONDS:
                            format = formatter.formatSeconds;
                            break;
                        case metricEnums.dataType.DURATION_MILLIS:
                            format = formatter.formatTimeInterval;
                            break;
                        default:
                            break;
                    }
                }

                if (_.isString(format)) {
                    return d3.format(format);
                }
                if (_.isFunction(format)) {
                    return function (value) {
                        return format.call(me, value, options);
                    };
                }

                return formatter.formats.abbreviated;
            },

            getValue: function () {
                const me = this;
                return me.attributes.value;
            },

            toJSON: function () {
                const me = this;
                const attributes = me.attributes;
                const formatter = me.getFormat(_.pick(attributes, 'alternate'));

                return _.extend({}, attributes, {
                    id: me.concept,
                    className: me.getClassName(),
                    parameters: me.getParameters(),
                    format: formatter
                });
            },

            toType: function () {
                const me = this;
                const attrs = me.unexpandedAttributes || me.attributes;
                return _.pick(attrs, [
                    'dataSource',
                    'property',
                    'dimensions',
                    'aggregate',
                    'over',
                    'channel',
                    'orderProperty',
                    'presence_id',
                    'name'
                ].concat(attrs.dimensions));
            },

            getGroupForUniversalApi: function () {
                const me = this;
                const timePeriod = me.get('timePeriod');
                return [
                    me.get('landscapeId'),
                    me.get('focusCompanyId'),
                    me.get('companySetDescriptor'),
                    [
                        [timePeriod.mainPeriodStart, timePeriod.mainPeriodEnd].join('-'),
                        [timePeriod.comparePeriodStart, timePeriod.comparePeriodEnd].join('-')
                    ]
                ].join('|');
            },

            getIdentityForUniversalApi: function () {
                const me = this;

                const attributes = me.resolvedAttributes();
                const data = _.pick(attributes, [
                    'dimensions',
                    'exclusions',
                    'exclusionDimension',
                    'property',
                    'source',
                    'limit',
                    'benchmarkCompaniesFilter',
                    'aggregate',
                    'timeAnalysisMode',
                    'over',
                    'companyIdAggregate',
                    'companySetIdAggregate',
                    'onlyCompanySetIds',

                    // Post metric attributes (note this is duplicated in the cache layer)
                    'orderBy',
                    'sortOrder',
                    'objectType',
                    'searchTerm',
                    'channel',
                    'mediaTypeFilter',
                    'tweetTypeFilter',
                    'postTagIds',
                    'postTagConjunction',
                    'postTagExclude'
                ].concat(attributes.dimensions));

                return [
                    me.getGroupForUniversalApi(),
                    objectHash(data)
                ].join('|');
            },

            getParameters: function () {
                const me = this;

                return _.extend({},
                    _.pick(me.attributes, 'timePeriod', 'companyId', 'presenceId', 'activeSources'),
                    _.get(me, 'description.parameters'), me.attributes.parameters);
            },

            getColor: function (data) {
                const me = this;

                if (me.getClassName(data)) {
                    return void 0;
                }

                let colorIdx = me.id;
                if (_.isString(colorIdx)) {
                    colorIdx = _.reduce(colorIdx, function (sum, c) {
                        return sum + c.charCodeAt(0);
                    }, 0);
                }

                // if we're part of a collection, use the index
                if (me.collection) {
                    const idx = me.collection.indexOf(me);
                    if (idx >= 0) {
                        colorIdx = idx;
                    }
                }

                // if we've been given an explicit color index, use that
                if (_.isFinite(me.get('colorIndex'))) {
                    colorIdx = me.get('colorIndex');
                }

                // TODO replace with custom scale?
                return d3.scale.category10().domain(d3.range(0, 10))(colorIdx % 10);
            },

            getPalette: function (index) {
                const me = this;
                const palette = me.source.palette || [];
                return palette[index % palette.length];
            },

            getSubmetricDefinitions: function () {
                const me = this;

                const useSourceName = me.get('useSourceNameForSubmetricLegend');
                const submetrics = new collections.MetricDefinitions(me.get('submetrics'));

                submetrics.each(function (metric) {
                    metric.attributes.legendName = (useSourceName ? metric.source.name : metric.getTitle({
                        abbreviate: true
                    }));
                });

                const bySource = submetrics.groupBy(function (metric) {
                    return metric.getSource();
                });

                _.each(bySource, function (group) {
                    _.each(group, function (metric, i) {
                        metric.attributes.className = metric.getPalette(i);
                    });
                });

                return submetrics;
            },

            // TODO replace getMetric with fetch for consistency with the collections
            fetch: function (companyData) {
                const me = this;
                return me.getMetric(companyData);
            },

            resolvedAttributes: function () {
                const me = this;
                return resolveAttributes(me.attributes);
            },

            getMetric: function (companyData) {
                const me = this;

                if (companyData instanceof collections.CompanyData) {
                    return new models.Metric(resolveAttributes(me.attributes), companyData);
                }

                const attrs = me._fetchAttributes(companyData);

                return RivalIQ.data.companyData.fetch(attrs, _.omit(attrs, 'timePeriod'))
                    .then(function (companyData) {
                        const metric = new models.Metric(resolveAttributes(me.attributes), companyData);
                        metric.unexpandedAttributes = me.unexpandedAttributes;

                        return metric;
                    });
            },

            _fetchAttributes: function (attrs) {
                const me = this;
                attrs = attrs || {};

                return _.defaults(attrs, me.getParameters(), {
                    timePeriod: me.getTimePeriod(),
                    sources: [me.getSource()]
                });
            },

            inheritedAttributes: [
                'timePeriod',
                'companyId',
                'combinePeriods',
                'interval',
                'presenceId'
            ],

            getChartData: function () {
                const me = this;

                return _.map(me.getTimeSpanData(), function (value, i) {
                    return [i, me.id, value];
                });
            },

            // Gets submetrics, returning a lazy loading collection if this metric
            // has not been fetched yet.
            getMetrics: function (attrs) {
                const me = this;

                attrs = _.extend(me._fetchAttributes(attrs), {
                    landscapeId: RivalIQ.state.view.get('landscapeId')
                });
                if (RivalIQ.data.companyData.isCached(attrs)) {
                    return me.getDimensions();
                }

                return new collections.LazyMetricDefinitions([], {
                    dimension: me
                });
            },

            getSource: function () {
                const me = this;
                return me.get('source');
            },

            serialize: function () {
                const me = this;
                return _.extend({
                    concept: me.get('concept')
                }, me.toType());
            },

            clone: function (attrs) {
                const me = this;
                return new models.MetricDefinition(_.extend({}, me.attributes, attrs));
            },

            getTimePeriod: function () {
                const me = this;

                if (me.attributes.timePeriod) {
                    return me.attributes.timePeriod;
                }

                return RivalIQ.state.view.get('timePeriod');
            },

            getInterval: function () {
                const me = this;

                return me.get('interval') || 'daily';
            },

            equal: function (other) {
                const me = this;

                if (!other) {
                    return false;
                }

                return me.id === other.id &&
                    _.reduce(me.inheritedAttributes, function (bool, attr) {
                        return bool && me.attributes[attr] === other.attributes[attr];
                    }, true);
            },

            isSummable: function () {
                const me = this;
                const isSummable = me.byField('summable');
                const nonSummable = _.values(_.pick(RivalIQ.enums.dataType, 'ABSOLUTE_PERCENT', 'DURATION_SECONDS', 'DURATION_MILLIS'));
                let dataType = me.get('dataType');
                if (_.isUndefined(dataType)) {
                    dataType = me.getType();
                }
                return !_.includes(nonSummable, dataType) && isSummable !== false;
            },

            /*
             * This poorly named function allows us to conditionally override
             * various metric properties based on the current dimension, property
             * and aggregate. The ordering and output here should still be
             * considered in-flux.
             *
             * key - the name of the overloaded function
             * data - the current data entry, if applicable. This lets us do things
             * like provide different class names for different values, e.g. post
             * types
             */
            byField: function (key, data, options) {
                const me = this;

                return me.byOverride(key, data) || me.byProperty(key, data, options);
            },

            byProperty: function (key, data, options) {
                const me = this;
                return dimensions.getProperty(me, key, data, options);
            },

            byAggregate: function (key, data, options) {
                const me = this;
                return me.byOverride(key, data, options) || aggregates.getAggregate(me, key, data, options);
            },

            // Allow overrides, especially useful for titles
            byOverride: function (key, data, options) {
                const me = this;
                if (!_.isUndefined(me.attributes[key])) {
                    const result = me.attributes[key];
                    return (_.isFunction(result) ? result(data, me, options) : result);
                }
            },

            byDimension: function (key, data, dimension, options) {
                const me = this;
                return dimensions.getDimensionProperty(me, dimension, key, data, options);
            },

            getName: function (options) {
                const me = this;
                return me.byOverride('name') || me.getTitle(options);
            },

            getDomainName: function (index) {
                const me = this;

                const ticks = me.getTick(index, {
                    format: false
                });

                if (!ticks || _.isEmpty(ticks)) {
                    // This happens when a tooltip tries to rendering during a d3 animation (the metric is in the new state, the graph has the old timeperiod still).
                    // Throw a special error so we can catch and ignore above.
                    const error = new Error('ticks not defined.');
                    error.name = 'ticks_not_defined';
                    throw error;
                }

                const startTick = me.domainFormat(ticks[0], {
                    expand: true
                });

                if (me.hasContinuousDomain()) {
                    return `${startTick} - ${me.domainFormat(ticks[1], {
                        expand: true,
                        roundToStart: false
                    })}`;
                }

                return startTick;
            },

            hasContinuousDomain: function () {
                const me = this;
                return me.get('interval') &&
                    me.get('interval') !== timePeriodEnums.period.day;
            },

            hasRelatedActivity: function () {
                const me = this;
                const channel = me.getChannel();
                const category = me.getMetricCategory();
                return !channel.get('privateData') &&
                    (category === RivalIQ.enums.category.ENGAGEMENT ||
                    category === RivalIQ.enums.category.ACTIVITY);
            },

            getSegments: _.noop,

            getDescription: function () {
                const me = this;
                return dimensions.getProperty(me, 'description');
            },

            getInformation: function (options) {
                const me = this;

                options = (options || {});

                const title = me.getName(options);
                // TODO why is this so hard? discuss with @abullrd
                // the problem seems to stem from behavior in `byProperty` that
                // defaults to Cross Channel descriptions based on the default
                // `property` of `count`. to get around this we first check for
                // a `description` in the attributes, then in the metric
                // description, and finally via `getDescription`.
                const description = (me.byOverride('description') ||
                    _.get(me, ['description', 'description'], me.getDescription()));

                return {
                    title: title,
                    content: description
                };
            },

            getOrderBy: function () {
                const me = this;

                return me.get('orderProperty') || me.get('property');
            },

            getChannel: function () {
                const me = this;
                return channels.get(me.get('channel') || me.get('source'));
            },

            getType: function () {
                const me = this;
                return me.byField('type');
            },

            getMetricType: function () {
                const me = this;
                return me.byField('metricType');
            },

            getNoHistoricData: function () {
                const me = this;
                return me.byField('noHistoricData');
            },

            getMetricValueType: function () {
                const me = this;
                return me.byField('metricValueType');
            },

            getMetricCategory: function () {
                const me = this;
                return me.byField('metricCategory');
            },

            getCategory: function () {
                const me = this;
                return me.byField('category');
            },

            getSortFunction: function () {
                const me = this;
                return me.byField('sort');
            },

            getCellView: function (data) {
                const me = this;

                if (me.cellView) {
                    return me.cellView;
                }

                if (me.get('property') === 'name') {
                    return me.byDimension('cellView', undefined, _.last(me.getFreeDimensions()));
                }

                return me.byField('cellView', data);
            },

            mustInclude: function (data) {
                const me = this;
                return me.byOverride('mustInclude', data) || me.byDimension('mustInclude', data, _.last(me.getFreeDimensions()));
            },

            isIntegerType: function () {
                const me = this;
                const dataType = me.byField('type');
                return (dataType === metricEnums.dataType.INTEGER);
            },

            formatUnabbreviated: function (value, options) {
                const me = this;

                if (me._isMissingValue(value)) {
                    return me.getMissingFormat(value);
                }

                return me.byField('formatUnabbreviated', value, options);
            },

            formatExpanded: function (data) {
                const me = this;
                return RivalIQ.metric.format.expandedFormatFn(me.attributes, data, {
                    expanded: true
                })(_.last(data));
            },

            /*
             * Gets the list of dimensions whose values have not been defined
             */
            getFreeDimensions: function () {
                const me = this;
                return metricFn.getFreeDimensions(me.attributes);
            },

            getPrimaryDimensionAndCalculationMetadata: function (data) {
                const me = this;

                const freeDimensions = me.getFreeDimensions();
                let primaryDimension = 'companyId';
                let primaryDimensionIdIdx = _.indexOf(freeDimensions, 'companyId');

                if (primaryDimensionIdIdx === -1) {
                    primaryDimension = _.head(freeDimensions);
                    primaryDimensionIdIdx = _.indexOf(freeDimensions, primaryDimension);
                }

                const primaryDimensionId = (data && primaryDimensionIdIdx !== -1 ? data[primaryDimensionIdIdx] : _.head(data));

                let dimensionValuePath = [primaryDimensionId];
                if (primaryDimension === 'companySetId') {
                    dimensionValuePath = ['calculationMetadataByCompanySetId', primaryDimensionId];
                }
                const calculationMetadata = me.getCalculationMetadata && me.getCalculationMetadata(dimensionValuePath);
                return {
                    primaryDimension: primaryDimension,
                    primaryDimensionId: primaryDimensionId,
                    calculationMetadata: calculationMetadata
                };
            },

            getChildProperties: function (options, channel) {
                const me = this;

                return _.filter(me.get('childProperties'), childProperty => {
                    if (_.isObject(childProperty)) {
                        if (channel && childProperty.excludedChannels) {
                            if (_.includes(childProperty.excludedChannels, channel.get('channel'))) {
                                return false;
                            }
                        }

                        if (options?.type && childProperty.type) {
                            return options.type === childProperty.type;
                        }
                    }
                    return true;
                });
            },

            /*
             * Returns child metric definitions for the current metric. These
             * metrics are valid for displaying in a table, detail view etc
             */
            getChildMetrics: function (options) {
                const me = this;
                options = options || {};

                const channel = me.getChannel();

                const channelColumns = (me.get('omitChannelMetrics') ? null : channel.getColumns());

                const childProperties = me.getChildProperties(options, channel);
                const channelProperties = _.get(me.get('channelProperties'), channel.attributes.channel);

                const channelPropertyNames = _.keyBy(channelProperties, channelProperty => channelProperty.property || channelProperty);

                let defs = _.compact(_.flatten([
                    channelColumns,
                    _.reject(childProperties, childProperty => { // this is to dedup metrics in cross channel and the channel itself.
                        return channelPropertyNames[childProperty];
                    }),
                    _.filter(channelProperties, function (metric) {
                        return _.isUndefined(metric.index);
                    })
                ]));

                defs = _.uniqBy(defs, def => {
                    return _.isString(def) ? def : def.property;
                });

                // sort metrics on side panel based on their custom index
                _.each(_.filter(channelProperties, function (metric) {
                    // NOTE to support type-specific metric in the single post modal, specify the metric type filter in
                    // the file public/modules/metrics.js
                    return !_.isUndefined(metric.index) && (!metric.type || !options.type || options.type === metric.type);
                }), function (metric) {
                    if (_.isNumber(metric.index)) {
                        defs.splice(metric.index, 0, metric.property);
                    }
                });

                if (options.union) {
                    // Select the union of all sub channel specific metrics
                    defs = defs.concat(_.flatten(channel.mapSubChannels(function (subChannel) {
                        return [subChannel.attributes.properties, _.get(me.get('channelProperties'), subChannel.attributes.channel)];
                    })));
                }

                if (options.omitProperties) {
                    defs = _.filter(defs, (def) => {
                        return !_.includes(options.omitProperties, (def.property || def));
                    });
                }

                let metrics = models.MetricDefinition.buildMetric(me, _.compact(_.flatten(defs)));

                if (options.categories) {
                    metrics = new collections.MetricDefinitions(metrics.filter(function (metric) {
                        return _.includes(options.categories, metric.getCategory());
                    }));
                }

                return metrics;
            },

            isValid: function () {
                const me = this;
                return !_.intersection(me.get('invalidDimensions'), me.get('dimensions')).length;
            },

            isOther: function () {

                const me = this;
                // TODO replace with a sort value concept (see @abullrd, @vjchem)
                return (me.getName() === 'Other');
            },

            /*
             * Get color for a value of this metric.
             * If there are free dimensions value should be an element of the
             * array returned by getValue
             */
            color: function (value, dimension) {
                const me = this;

                const freeDimensions = me.getFreeDimensions();

                if (!dimension) {
                    dimension = _.last(freeDimensions) || _.last(me.get('dimensions'));
                }

                if (!_.isUndefined(me.get(dimension))) {
                    value = me.get(dimension);
                }

                if (_.isArray(value)) {
                    value = value[_.indexOf(freeDimensions, dimension)];
                }

                return me.byDimension('color', value, dimension);
            },

            format: function (data, options) {
                const me = this;
                let format;

                let value = data;
                if (_.isArray(data)) {
                    value = _.last(data);

                    // NOTE: metric widget nests it's value within a data array
                    if (_.isArray(value)) {
                        value = _.last(value);
                    }
                }

                if (me._isMissingValue(value)) {
                    return me.byProperty('missingDataFormat', data, options);
                }

                if (_.isString(value) && value.length === 0) {
                    return me.getEmptyStringFormat(data, options);
                }

                if (me.get('aggregate')) {
                    format = me.byAggregate('format', value, options);
                }

                if (format) {
                    return format;
                }

                // NOTE used by the glance widget, can be removed when its
                // format is updated
                const formatFn = _.get(me, ['description', 'valueFormat']);
                if (formatFn) {
                    return formatFn(value);
                }

                return me.byOverride('valueFormat', data, options) ||
                    me.byProperty('format', data, options);
            },

            getIncompleteBuckets: function () {
                const me = this;

                const buckets = _.last(me.getDomainRange());
                const result = _.reduce(_.range(buckets), function (memo, idx) {
                    const bucketTimePeriod = me.getBucketTimePeriod(idx);
                    return (bucketTimePeriod.incomplete ? memo.concat(idx) : memo);
                }, []);

                return result;
            },

            getBucketTimePeriod: function (idx) {
                const me = this;
                let incomplete = false;
                const period = _.get(RivalIQ.utils.timePeriod.interval, [me.get('interval')], RivalIQ.utils.timePeriod.interval.daily);

                let bucketStartDate = me.getStartDate().add(idx, period).startOf(period);
                if (bucketStartDate < me.getStartDate()) {
                    bucketStartDate = me.getStartDate();
                    incomplete = true;
                }

                let bucketEndDate = me.getStartDate().add(idx, period).endOf(period);
                if (bucketEndDate > me.getEndDate()) {
                    bucketEndDate = me.getEndDate();
                    incomplete = true;
                }

                return {
                    start: bucketStartDate,
                    end: bucketEndDate,
                    incomplete: incomplete,
                    duration: bucketEndDate.diff(bucketStartDate, 'day', true)
                };
            },

            _intervalMetricDomainFormat: function (value, options) {
                const me = this;

                let date = value;
                if (!moment.isMoment(value)) {
                    date = _.head(me.getDataDate(value));
                }
                const roundToStart = options?.roundToStart ?? true;
                let format;
                switch (me.get('interval')) {
                    case 'weekly': {
                        format = 'MM/DD';
                        if (roundToStart) {
                            date = date.startOf('week');
                        }
                        break;
                    }

                    case 'monthly': {
                        format = 'MMM';
                        if (roundToStart) {
                            date = date.startOf('month');
                        }
                        break;
                    }

                    default: {
                        format = 'MM/DD';
                    }
                }

                return (options?.expand ? formatter.formats.date(value) : date.format(format));
            },

            _getIntervalMetricTicks: function (count) {
                const me = this;

                const range = me.getDomainRange();

                // If we're weekly and the first tick is a partial week, we're not going to draw a tick for it.
                if (!me.get('forceShowFirstTick') && me.get('interval') === 'weekly') {
                    const firstTickDate = me.getDataDate(range[0])[0];
                    if (firstTickDate.isAfter(firstTickDate.clone().startOf('week'))) {
                        range[0] += 1;
                    }
                }

                const rangeStart = _.head(range);
                const rangeEnd = _.last(range);
                const length = rangeEnd - rangeStart;

                const values = _.range(rangeStart, rangeEnd);

                // Lots of magic numbers here! Basically, if we have T ticks for N values,
                // there will be T ticks and T-1 gaps between those ticks. We want the gaps to be
                // generally the same size as the graphs look ugly when the gap lengths are too varied.
                // If G is a gap size, then we're looking at a function like
                // T + G(T-1) ~= N
                // where we want choose T and G so that T < ticks passed in, G is an integer, and we
                // the left side of that equation as close to N as possible. These magic, hand-crafted
                // numbers get us there.
                let ticks;
                switch (length) {
                    case 11:
                        ticks = 6;
                        break;
                    case 12:
                        ticks = 6;
                        break;
                    case 13:
                        ticks = 7;
                        break;
                    case 14:
                        ticks = 4;
                        break;
                    case 15:
                        ticks = 9;
                        break;
                    case 16:
                        ticks = 6;
                        break;
                    case 17:
                        ticks = 9;
                        break;
                    case 18:
                        ticks = 4;
                        break;
                    default: {
                        if (length <= 10) {
                            ticks = length;
                        } else if (length % 2 === 0) {
                            if (length % 6 === 0) {
                                ticks = 6;
                            } else {
                                ticks = 4;
                            }
                        } else {
                            ticks = Math.min(count || 2, length);
                        }
                    }
                }

                if (RivalIQ.utils.browser.isMobile()) {
                    ticks = Math.min(ticks, 6);
                }

                if (length <= ticks) {
                    ticks = Math.min(ticks || 2, range[1] - range[0]);

                    if (ticks === 1) {
                        return [Math.floor(range[0] + ((range[1] - range[0] - 1) / 2))];
                    }

                    if (ticks === 2) {
                        return [rangeStart, rangeEnd - 1];
                    }

                    const step = Math.floor((range[1] - 1) / (ticks - 1));
                    return _.map(_.range(0, ticks), function (ticks, tick) {
                        return rangeStart + tick * step;
                    });
                }

                if (ticks % 2 !== length % 2) {
                    ticks--;
                }

                // This is the case where we have an even number of ticks and an even number of values.
                if (ticks % 2 === 0 && length % 2 === 0) {

                    const ticksToFill = _.times(length, _.constant(false));
                    let ticksRemaining = ticks;

                    ticksToFill[0] = true;
                    ticksToFill[length - 1] = true;
                    ticksRemaining -= 2;
                    let lastLeftTickIdx = 0;
                    let lastRightTickIdx = length - 1;

                    for (; ticksRemaining > 0; ticksRemaining -= 2) {
                        let leftTickCandidate = lastLeftTickIdx + 2;
                        let lastRightCandidate = lastRightTickIdx - 2;

                        if (ticksRemaining === 2) {
                            const remainingTickSpaceSize = lastRightTickIdx - lastLeftTickIdx + 1;
                            const inset = Math.round((remainingTickSpaceSize - ticksRemaining) / 3);

                            leftTickCandidate = lastLeftTickIdx + inset;
                            lastRightCandidate = lastRightTickIdx - inset;
                        } else {
                            const remainingTickSpaceSize = lastRightCandidate - leftTickCandidate + 1;
                            let inset = Math.round((remainingTickSpaceSize - ticksRemaining) / (ticksRemaining - 1));
                            inset = Math.max(2, inset);
                            leftTickCandidate = lastLeftTickIdx + inset;
                            lastRightCandidate = lastRightTickIdx - inset;
                        }

                        ticksToFill[leftTickCandidate] = true;
                        ticksToFill[lastRightCandidate] = true;
                        lastLeftTickIdx = leftTickCandidate;
                        lastRightTickIdx = lastRightCandidate;
                    }

                    return _.reduce(ticksToFill, (memo, value, idx) => {
                        if (value) {
                            memo.push(idx);
                        }
                        return memo;
                    }, []);
                } else {

                    const step = Math.round(_.last(_.initial(values)) / (ticks - 2));
                    const innerTicks = _.take(_.range(rangeStart + step, rangeEnd - step + 1, step), ticks - 2);

                    return [].concat(
                        _.head(values),
                        innerTicks,
                        _.last(values)
                    );
                }
            }
        });

        models.Metric = models.MetricDefinition.extend({

            /**
             * The value to substitute for display when data is missing.
             */
            missingDataDisplayValue: '--',

            initialize: function (attrs, data) {
                const me = this;

                models.MetricDefinition.prototype.initialize.call(me, attrs);
                me.data = data;
                me.compareData = _.get(data, 'compareData');

                if (me.over) {
                    me.over = new RivalIQ.models.Metric(me.over.attributes, data);
                }
            },

            canGetNormalizedValue: function (companyId, presenceId) {
                const me = this;
                companyId = (companyId || me.attributes.companyId);
                presenceId = (presenceId || me.attributes.presenceId);
                const company = me.data.get(companyId);
                return company.hasNormalizedData(me.id, presenceId);
            },

            // TODO we should re-examine this method, as it would be preferable
            // to simply handle normalized data via `getValue`, or some other
            // simpler mechanism /cc @abullrd
            isNormalizable: function () {
                const me = this;

                const timePeriod = me.getTimePeriod();
                let mainPeriodDuration = timePeriod.mainPeriodDuration;
                if (!mainPeriodDuration) {
                    mainPeriodDuration = moment.utc(timePeriod.mainPeriodEnd).diff(moment.utc(timePeriod.mainPeriodStart), 'days');
                }
                let comparePeriodDuration = timePeriod.comparePeriodDuration;
                if (!comparePeriodDuration) {
                    comparePeriodDuration = moment.utc(timePeriod.comparePeriodEnd).diff(moment.utc(timePeriod.comparePeriodStart), 'days');
                }

                const isVaryingDuration = (mainPeriodDuration !== comparePeriodDuration);
                const isSourceNormalizable = _.get(me, ['source', 'normalizable'], false);
                return (isSourceNormalizable && isVaryingDuration);
            },

            // TODO we have the same question, concern as `isNormalizable`
            isNormalized: function () {
                const me = this;
                return (me.canGetNormalizedValue() && me.get('normalized'));
            },

            getValue: function (options) {
                const me = this;
                options = options || {};

                if (_.exists(me.attributes.value)) {
                    return me.attributes.value;
                }

                const valueType = options.value || metricEnums.valueType.CURRENT;
                _.extend(options, _.pick(me.attributes, 'presenceId'), {
                    value: valueType
                });
                // NOTE only summable metrics can have valid normalized values so
                // we should just return whatever we have in the existing rollups
                if (me.attributes.normalized && me.isSummable()) {
                    options.mode = 'normalized';
                }

                // TODO support passing no companyId or array
                const companyData = me.data.get(me.attributes.companyId);
                let result;
                if (companyData) {
                    result = companyData.getValueData(me.id, valueType, options);
                }

                if (options.format === false) {
                    return result;
                }

                return me.format(result, options);
            },

            axisFormat: function (value, options) {
                const me = this;
                return me.byField('axisFormat', value, options) || me.format(value, options);
            },

            formatDimension: function (dimension, value, options) {
                const me = this;
                return dimensions.getDimensionProperty(me, dimension, 'format', value, options);
            },

            domainFormat: function (value, options) {
                const me = this;
                options = options || {};

                if (me.get('useIntervalDomainFormatting') && !options.expand) {
                    return me._intervalMetricDomainFormat(value, options);
                }

                const formatted = me.byDimension('format', value, undefined);

                if (_.isString(formatted)) {
                    return formatted;
                }

                return (options.expand ? formatter.formats.date(value) : value.format('MM/DD/YYYY'));
            },

            csvFormat: function (value, options) {
                const me = this;
                let format;

                if (me.get('aggregate')) {
                    format = me.byAggregate('csvFormat', value);
                }

                return format || me.byField('csvFormat', value, options);
            },

            getDeltaRel: function (options) {
                const me = this;
                return me.getValue(_.extend({}, options, {
                    value: metricEnums.valueType.DELTA_REL
                }));
            },

            getTimeSpanData: function () {
                const me = this;

                const options = _.pick(me.attributes, 'presenceId');
                options.includeComparePeriod = Boolean(me.attributes.combinePeriods) && me._timePeriodsAbutting();
                options.serverRollup = Boolean(me.get('serverRollup'));
                const timeAnalysisMode = me.getTimeAnalysisMode();

                // TODO support passing no companyId or array
                return me.data.get(me.attributes.companyId).getTimeSpanData(me.attributes.id, me.getDataTimePeriod(), timeAnalysisMode, options);
            },

            getTimeAnalysisMode: function () {
                const me = this;

                const interval = me.get('interval');
                if (interval) {
                    switch (interval) {
                        case timePeriodUtils.period.week:
                            return timeAnalysisMode.WEEKLY_VALUES;

                        case timePeriodUtils.period.month:
                            return timeAnalysisMode.MONTHLY_VALUES;

                        case timePeriodUtils.period.day:
                        default:
                            return timeAnalysisMode.MAIN_PERIOD;
                    }
                }

                return (_.exists(me.attributes.timeAnalysisMode) ?
                    me.attributes.timeAnalysisMode : timeAnalysisMode.MAIN_PERIOD);
            },

            getTimePeriodType: function () {
                const me = this;
                return me.attributes.timePeriodType;
            },

            getDimension: function (key) {
                const me = this;

                const metricDefinition = models.MetricDefinition.prototype.getDimension.call(me, key);
                return metricDefinition.getMetric(me.data);
            },

            clone: function (attrs) {
                const me = this;
                return new models.Metric(_.extend({}, me.attributes, attrs), me.data);
            },

            // TODO should not require companyData or be companyData metric
            // specific
            getDataTimePeriod: function () {
                const me = this;

                if (!me._getDataTimeperiod) {
                    me._getDataTimeperiod = _.memoize(function (companyId, source, period, presenceId) {
                        return me.data.get(companyId).getTimePeriod(source, period, presenceId);
                    }, function () {
                        return Array.prototype.join.call(arguments, '.') + me.getTimePeriod().uuid;
                    });
                }

                const period = timePeriodEnums.interval[me.get('interval')];
                // TODO handle no company id / company id array
                return me._getDataTimeperiod(me.attributes.companyId, me.get('source'), period, me.get('presenceId'));
            },

            showTrailingPeriod: function () {
                const me = this;
                return me.get('combinePeriods') && me._timePeriodsAbutting();
            },

            getStartDate: function () {
                const me = this;
                const timePeriod = me.getDataTimePeriod();

                if (me.showTrailingPeriod()) {
                    return timePeriod.comparePeriodStart;
                }

                return moment.utc(timePeriod.mainPeriodStart);
            },

            getEndDate: function () {
                const me = this;
                const timePeriod = me.getDataTimePeriod();

                return moment.utc(timePeriod.mainPeriodEnd);
            },

            getPeriod: function () {
                const me = this;
                return timePeriodEnums.interval[me.getInterval()];
            },

            /*
             * Returns the [start, end] of the of this metric.
             * Typically this is the start date and end date indices, but it can
             * also be hours, days of the week, etc
             */
            getDomainRange: function () {
                const me = this;

                const range = me.getMainPeriodDomainRange();
                return [0, range[1]];
            },

            /*
             * Given a value in the domain return its index for graphing
             */
            domainIndex: function (value) {
                const me = this;
                let i = 0;

                while (value.isAfter(me.getDataDate(i)[1])) {
                    i++;
                }

                return i;
            },

            getMainPeriodDomainRange: function (period) {
                const me = this;

                period = period || me.getPeriod();
                const timePeriod = me.getDataTimePeriod();

                const range = domainRange(timePeriod.mainPeriodStart, timePeriod.mainPeriodEnd, period);
                if (me.showTrailingPeriod()) {
                    const offset = domainRange(timePeriod.comparePeriodStart, timePeriod.comparePeriodEnd, period)[1];
                    return [range[0] + offset, range[1] + offset];
                }

                return range;
            },

            getComparePeriodDomainRange: function (period) {
                const me = this;

                if (!me.showTrailingPeriod()) {
                    return [0, 0];
                }

                period = period || me.getPeriod();
                const timePeriod = me.getDataTimePeriod();

                return domainRange(timePeriod.comparePeriodStart, timePeriod.comparePeriodEnd, period);
            },

            getDataDate: function (index) {
                const me = this;

                const period = me.getPeriod();
                if (!me._dataDates) {
                    let ranges = ['main'];
                    const timePeriod = me.getDataTimePeriod();
                    if (me.showTrailingPeriod()) {
                        ranges = ['compare'].concat(ranges);
                    }

                    me._dataDates = {};
                    let i = 0;
                    _.each(ranges, function (range) {
                        const periodStart = moment.utc(timePeriod[`${range}PeriodStart`]);
                        const periodEnd = moment.utc(timePeriod[`${range}PeriodEnd`]);

                        const start = periodStart;
                        const end = periodEnd;

                        const periodLength = RivalIQ.utils.timePeriod.getPeriodCount(start, end, period);
                        for (let j = 0; j < periodLength - 1; j++) {
                            me._dataDates[i++] = [start.clone(), start.clone().endOf(period)];
                            start.startOf(period).add(1, period);
                        }

                        me._dataDates[i++] = [start.clone(), end.clone()];
                    });
                }

                // clone the moments in case any callers decide to mutate them.
                return _.map(me._dataDates[index], date => date.clone());
            },

            getTicks: function (count) {
                const me = this;

                if (me.get('useIntervalDomainFormatting')) {
                    return me._getIntervalMetricTicks(count);
                }

                const range = me.getDomainRange();
                count = Math.min(count || 2, range[1] - range[0]);

                if (count === 1) {
                    return [Math.floor(range[0] + ((range[1] - range[0] - 1) / 2))];
                }

                const step = Math.floor((range[1] - 1) / (count - 1));
                return _.map(_.range(0, count), function (ticks, tick) {
                    return tick * step;
                });
            },

            getTick: function (index, options) {
                const me = this;
                options = _.defaults({}, options, {
                    format: true
                });

                const dates = me.getDataDate(index);

                if (options.format) {
                    return me.domainFormat(dates[0], options);
                }

                return dates;
            },

            isTrailing: function (index) {
                const me = this;

                if (!me.showTrailingPeriod()) {
                    return false;
                }

                return index < me.getDataTimePeriod().comparePeriodIntervalDuration;
            },

            _timePeriodsAbutting: function () {
                const me = this;

                const timePeriod = me.getTimePeriod();
                return moment.utc(timePeriod.mainPeriodStart).diff(moment.utc(timePeriod.comparePeriodEnd), 'day', true) <= 1;
            },

            getEarliestDataKey: function () {
                const metric = this;
                const noHistoricData = metric.byField('noHistoricData');

                let earliestDataKey;
                const source = metric.getSource();
                if (RivalIQ.enums.sourceDetails[Number(source)].privateData) {

                    switch (RivalIQ.metric.property.hasEnoughDataKey(metric.attributes)) {
                        case 'PrivateStatisticsData':
                            return 'private_statistics_history_since';

                        case 'PrivatePresenceData':
                            return 'private_presence_history_since';

                        case 'PrivateStoriesData':
                            return 'private_stories_history_since';

                        case 'PrivatePostData':
                        default:
                            return 'private_post_history_since';
                    }
                } else {
                    if (noHistoricData) {
                        earliestDataKey = (source === RivalIQ.enums.sources.CROSS_CHANNEL ? 'firstPresenceData' : 'earliestPresenceData');
                    } else {
                        earliestDataKey = 'earliestPostData';
                    }
                }

                return earliestDataKey;
            },

            getEarliestDataDate: function () {
                const me = this;
                const earliestDataKey = me.getEarliestDataKey();
                const trendKey = _.get(RivalIQ.enums.sourceDetails[me.get('source')], ['trendKey']);
                if (me.data.companyData) {
                    // universal metrics only
                    return _.reduce(me.data.companyData, (memo, company) => {
                        memo[company.id] = _.get(company, [
                            'periodSummary',
                            trendKey,
                            0,
                            'dates',
                            earliestDataKey
                        ]);
                        return memo;
                    }, {});
                }

                const company = me.compareData.companiesById[me.data.companyId];
                const record = RivalIQ.utils.companyDisplay.getSourcePrimaryRecord(me.get('source'), company);
                return {
                    [me.data.companyId]: _.get(record, ['dates', earliestDataKey])
                };
            },

            getObjectType: function () {
                const metric = this;

                const source = metric.get('source');

                if (metricEnums.sourceDetails[Number(source)].privateData) {
                    const enoughDataKey = RivalIQ.metric.property.getEnoughDataKey(metric.attributes);
                    return enoughDataKey === 'stories' ? enoughDataKey : 'post';
                }

                return 'post';
            }
        });

        function converted(val) {
            return !_.exists(val) ||
                val instanceof models.MetricDefinition ||
                val instanceof collections.MetricDefinitions;
        }

        /*
         * Converts the passed in identifiers to metric definitions or passes
         * through existing metric definitions
         */
        models.MetricDefinition.convert = function (obj) {
            const keys = _.tail(arguments);
            _.each(keys, function (key) {
                const val = obj[key];

                if (converted(val)) {
                    return;
                }

                if (_.isArray(val)) {
                    obj[key] = new collections.MetricDefinitions(val);
                } else {
                    obj[key] = new models.MetricDefinition(val);
                }
            });
        };

        /*
         * Converts metric definitions from the provided metric or passes through
         * existing metric definitions
         */
        models.MetricDefinition.build = function (obj, metric, overrides) {
            const keys = _.drop(arguments, 3);

            _.each(keys, function (key) {
                let val = obj[key];

                if (converted(val)) {
                    return;
                }

                function convert(originalProps) {
                    if (_.isString(originalProps)) {
                        originalProps = {
                            property: originalProps
                        };
                    }

                    originalProps = _.extend(originalProps, overrides);
                    const expanded = expansions.expandDefinition(originalProps, metric);

                    const properties = (expanded ? expanded : originalProps);

                    const submetricDefinitions = _.pick(properties, 'submetrics');

                    let child;
                    if (metric) {
                        child = metric.build(_.omit(properties, 'submetrics'));
                    } else {
                        child = new models.MetricDefinition(_.omit(properties, 'submetrics'));
                    }

                    models.MetricDefinition.build(submetricDefinitions, child, {}, 'submetrics');
                    _.extend(child.attributes, submetricDefinitions);

                    if (expanded) {
                        child.unexpandedAttributes = _.create(_.get(metric, 'attributes', {}), originalProps);
                    }

                    return child;
                }

                if (_.isArray(val) || val.toArray) {
                    val = (val.toJSON ? val.toJSON() : val);
                    obj[key] = new collections.MetricDefinitions(_.map(val, convert));
                } else {
                    obj[key] = convert(val);
                }
            });
        };

        models.MetricDefinition.buildMetric = function (metric, value, overrides) {
            const tmp = {
                metric: value
            };
            models.MetricDefinition.build(tmp, metric, overrides || {}, 'metric');
            return tmp.metric;
        };

        models.MetricDefinition.exists = function (concept) {
            concept = (_.isObject(concept) ? concept.id || concept.concept : concept);
            const description = _.find(metrics.descriptions, {
                id: concept
            });
            return Boolean(concept) && Boolean(description);
        };

        function domainRange(start, end, period) {
            return [0, timePeriodUtils.getPeriodCount(start, end, period, false)];
        }

        function getMetricModels() {
            // NOTE see comment near top of file about delayed initialization
            if (base.shouldInitializeMetricModels) {
                base.initializeMetricModels();
                base.shouldInitializeMetricModels = false;
            }
            return base;
        }

        /**
         * A factory to get a metric definition from attributes.
         * NOTE: this is needed so that the server can access the appropriate
         * models, primarily in CSV export scenarios.
         * @param {Object} attributes
         */
        function getMetricModel(attributes) {
            const metricModels = getMetricModels();

            let model;
            switch (attributes.dataSource) {
                case 'mentions':
                    model = metricModels.MentionCompanySummary;
                    break;
                case 'mentioners':
                    model = metricModels.Mentioners;
                    break;
                case 'top_mentions':
                    model = metricModels.Mention;
                    break;
                case 'discovery':
                    model = metricModels.Discovery;
                    break;
                case 'instagramInsightsFollowerOnlineTimes':
                    model = metricModels.InstagramFollowerOnlineTimes;
                    break;
                default:
                    switch (attributes.source) {
                        case metricEnums.sources.FACEBOOK_ADS:
                            model = metricModels.FbAdObjects;
                            break;
                        default:
                            model = metricModels.Base;
                    }
            }

            return model;
        }
    }

    /*
     * Gets the full resolved attributes hash
     * Useful for serialization and copying a metric definition
     */
    function resolveAttributes(attributes) {
        const attrs = {};

        // Intentionally traverse the prototypes -- in other words,
        // don't protect this loop with hasOwnProperty; grab everything
        // up the prototype chain.
        for (const key in attributes) { /* eslint-disable-line guard-for-in */
            attrs[key] = attributes[key];
        }

        return attrs;
    }

})();
